















































































































































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { Location } from "vue-router";
import { Validator } from "vee-validate";
import ManageFundingFile from "@/employer/components/shared/ManageFundingFile.vue";
import EmployeesNavigation from "@/employer/components/user-management/EmployeesNavigation.vue";
import HowItWorksWidget from "@/employer/components/shared/HowItWorksWidget.vue";
import CensusUploadModal from "@/employer/components/profile/CensusUploadModal.vue";
import BulkEnrollmentUploadModal from "@/employer/components/profile/BulkEnrollmentUploadModal.vue";
import CensusFileUploadResultsPanel from "@/employer/components/profile/CensusFileUploadResultsPanel.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import { EnrollmentOption } from "@/shared/types";
import {
  CensusUploadStatus,
  EmployerCensusFile,
  CensusManager,
  CensusUploadType
} from "@/employer/types";
import * as employeeNavigatorUrls from "@/shared/employeeNavigatorUrls";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useCensusFileStore } from "@/employer/store/censusFile";
import { useEmployeeStore } from "@/employer/store/employee";
import { useProfileStore } from "@/employer/store/profile";

@Component({
  components: {
    EmployeesNavigation,
    ManageFundingFile,
    HowItWorksWidget,
    CensusUploadModal,
    Pagination,
    PageSizeSelectList,
    Pill,
    CensusFileUploadResultsPanel,
    BulkEnrollmentUploadModal
  }
})
export default class EmployerCensusUpload extends Vue {
  $validator: Validator;
  EmployeeNavigatorUrls = employeeNavigatorUrls;
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  censusFileStore = useCensusFileStore();
  employeeStore = useEmployeeStore();
  profileStore = useProfileStore();


  @Prop()
  page: number;

  @Prop()
  routeToCensusFileUploadView: (page: number) => Location;

  mounted (): void {
    this.censusFileStore.loadFileList({
      employerId: this.employerId,
      pageNumber: this.page
    });
    this.$on("refreshFileUpload", () => {
      this.$router.push(this.routeToCensusFileUploadView(1));
      this.censusFileStore.reloadFileList(this.employerId);
    });
    this.profileStore.loadEnrollmentOption(this.employerId);
  }

  get employerId (): number {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.employerId) {
      return this.userStore.currentEmployer.employerId;
    }

    return 0;
  }

  get displayEmployeeNavigatorContent (): boolean {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.censusManager === CensusManager.employeeNavigator;
  }

  selectFile (event, file: EmployerCensusFile): void {
    event.preventDefault();
    this.censusFileStore.loadFileDetails({ censusFileId: file.employerCensusFileId, employerId: this.employerId });
  }

  get allowCensusUpload (): boolean {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.censusManager === CensusManager.bend
      && this.userStore.currentEmployer.isTerminated === false && this.censusFileStore.hasFilePendingInProcess === false;
  }

  get isBulkEmployer (): boolean {
    return this.profileStore.enrollmentOption === EnrollmentOption.EmployerBulk;
  }

  get fileFormattingGuidelinesModal (): string {
    if (this.isBulkEmployer) {
      return "bulkenrollment-upload-modal";
    }
    return "census-upload-modal";
  }

  get fileTemplate () {
    if (this.isBulkEmployer) {
      return "/bulk_enrollment_template.csv";
    }
    return "/template.csv";
  }

  getPillClass (status: CensusUploadStatus): string {
    switch (status) {
      case CensusUploadStatus.Pending: {
        return "neutral-pill";
      }
      case CensusUploadStatus.Fail: {
        return "error-pill";
      }
      case CensusUploadStatus.SomeErrors: {
        return "warning-pill";
      }
      default: {
        return "success-pill";
      }
    }
  }

  getStatusText (status: CensusUploadStatus): string {
    switch (status) {
      case CensusUploadStatus.NoErrors: {
        return "No Errors";
      }
      case CensusUploadStatus.SomeErrors: {
        return "Some Errors";
      }
      default: {
        return status;
      }
    }
  }

  getTypeText (status: CensusUploadType): string {
    switch (status) {
      case CensusUploadType.Web: {
        return "Web";
      }
      case CensusUploadType.Sftp: {
        return "SFTP";
      }
      case CensusUploadType.EmployeeNavigator: {
        return "Employee Navigator";
      }
      default: {
        return "None";
      }
    }
  }

  switchPageSize (): void {
    // on switching page size, reset to page 1
    this.$router.push(this.routeToCensusFileUploadView(1));
    this.censusFileStore.reloadFileList(this.employerId);
  }

  switchPage (toPage: number): void {
    this.$router.push(this.routeToCensusFileUploadView(toPage));
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.censusFileStore.loadFileList({
      employerId: this.employerId,
      pageNumber: this.page
    });
  }

  handleError (err: any): void {
    this.notifierStore.setDanger(err || "Error processing your request. Please try again later");
  }

  isResultFileDownloadDisabled (file: EmployerCensusFile): boolean {
    return !file ||
      !file.uploadStatus ||
      file.uploadStatus === CensusUploadStatus.None ||
      file.uploadStatus === CensusUploadStatus.Pending;
  }

  resultFileDownloadButtonText (file: EmployerCensusFile): string {
    return this.isResultFileDownloadDisabled(file) ? "Waiting" : "Download";
  }

  onResultFileDownloadClick (file: EmployerCensusFile): void {
    this.censusFileStore.downloadCensusFileResult({
      employerId: this.employerId,
      censusFileId: file.employerCensusFileId
    });
  }
}
